"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENTS_WHITE = exports.PAYMENTS_LIGHT_GRAY = exports.PAYMENTS_BLACK = exports.PAYMENTS_GREY = exports.DATE_FORMAT = exports.PaymentMethodEnum = void 0;
var PaymentMethodEnum;
(function (PaymentMethodEnum) {
    PaymentMethodEnum["WIRE"] = "Wire";
    PaymentMethodEnum["CASH"] = "Cash";
    PaymentMethodEnum["CC"] = "Credit Card";
    PaymentMethodEnum["EFT"] = "ACH Deduction";
    PaymentMethodEnum["EF"] = "Customer ACH";
    PaymentMethodEnum["FIS"] = "Online Check";
    PaymentMethodEnum["ACH"] = "ACH Online";
    PaymentMethodEnum["MO"] = "Money Order/ Cashiers' Check";
    PaymentMethodEnum["ARC460"] = "Credit/ Debit Offset";
    PaymentMethodEnum["CHECK"] = "Check";
    PaymentMethodEnum["OTHER"] = "Other/ Adjustment";
})(PaymentMethodEnum = exports.PaymentMethodEnum || (exports.PaymentMethodEnum = {}));
exports.DATE_FORMAT = "M/d/yyyy";
exports.PAYMENTS_GREY = "#585858";
exports.PAYMENTS_BLACK = "#2F2F2F";
exports.PAYMENTS_LIGHT_GRAY = "#B6B6B6";
exports.PAYMENTS_WHITE = "FFFFFF";
